import mobWebp from '../../images/about/mobile/people.webp';
import mobWebp2x from '../../images/about/mobile/people@2x.webp';
import mobJpeg from '../../images/about/mobile/people.jpg';
import mobJpeg2x from '../../images/about/mobile/people@2x.jpg';

import tabletWebp from '../../images/about/tablet/people.webp';
import tabletWebp2x from '../../images/about/tablet/people@2x.webp';
import tabletJpeg from '../../images/about/tablet/people.jpg';
import tabletJpeg2x from '../../images/about/tablet/people@2x.jpg';

import deskWebp from '../../images/about/desktop/people.webp';
import deskWebp2x from '../../images/about/desktop/people@2x.webp';
import deskJpeg from '../../images/about/desktop/people.jpg';
import deskJpeg2x from '../../images/about/desktop/people@2x.jpg';

export const images = {
  mobWebp,
  mobWebp2x,
  mobJpeg,
  mobJpeg2x,
  tabletWebp,
  tabletWebp2x,
  tabletJpeg,
  tabletJpeg2x,
  deskWebp,
  deskWebp2x,
  deskJpeg,
  deskJpeg2x,
};
